import { ANNOUNCEMENT_LIST } from '../../constants';

const initialState = {
  loading: true,
  data: [],
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ANNOUNCEMENT_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ANNOUNCEMENT_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ANNOUNCEMENT_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};
